export const lightTheme = {
    body: "#fff",
};

export const darkTheme = {
    body: "#141414",
};
